import { type ResponseItemType } from '@/common/types/response.type';
import { type SearchCombinedResult } from '@/common/types/searchResult.type';
import { useMutation } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';
import { createQueryStringUtility } from '@/common/utils/create-query-string.utility';

export interface SearchCombinedPayloadType {
  queryText?: string;
  categoryId?: number;
  suggestTake?: number;
  categoryTake?: number;
  vendorTake?: number;
}

export type SearchCombinedType = (
  params: SearchCombinedPayloadType
) => Promise<ResponseItemType<SearchCombinedResult>>;

const searchCombinedService: SearchCombinedType = async (
  payload: SearchCombinedPayloadType
) => {
  const client = new Client(true);

  return await client.get(
    `/v1/Search/Combined/${createQueryStringUtility({ ...payload })}`
  );
};

export const useSearchCombined = () => {
  return useMutation({
    mutationKey: ['SearchCombined'],
    mutationFn: async (params: SearchCombinedPayloadType) =>
      await searchCombinedService(params),
  });
};
